import React from "react";
import AttendanceReports from "../../components/features/attendance/AttendanceReport";

const AttendanceReportsPage = () => {
  return <AttendanceReports />;
};

export default AttendanceReportsPage;
